export const seriesData = {
	"series_name": "2023 World Cup",
	"groups":[
		{
			groupDisplayName:"2023 World Cup",
			groupName:"groupA",
			teamFlags:{
				"Zimbabwe":"https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340500/340503.png",
				"Netherlands":"https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313136.logo.png",
				"West Indies":"https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/317600/317615.png",
				"Sri Lanka":"https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340000/340047.png",
				"Scotland":"https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313150.logo.png",
				"Oman":"https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/358500/358573.png",
				
			},
			FinshedMatches:[
				{
					"matchId": 1,
					"team1": "England",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313114.logo.png",
					"team2": "New Zealand",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340500/340505.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Thu, 05 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 2,
					"team1": "Netherlands",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313136.logo.png",
					"team2": "Pakistan",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313129.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Fri, 06 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 3,
					"team1": "Afghanistan",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/321000/321005.png",
					"team2": "Bangladesh",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/341400/341456.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Sat, 07 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 4,
					"team1": "South Africa",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313125.logo.png",
					"team2": "Sri Lanka",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340000/340047.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "",
					"wDescription": ""
				},
				{
					"matchId": 5,
					"team1": "India",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313128.logo.png",
					"team2": "Australia",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340400/340493.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Sun, 08 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 6,
					"team1": "Netherlands",
					"team1Flag": "https://wassets.hscicdn.com/static/images/lazyimage-transparent.png",
					"team2": "New Zealand",
					"team2Flag": "https://wassets.hscicdn.com/static/images/lazyimage-transparent.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Mon, 09 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 7,
					"team1": "Bangladesh",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/341400/341456.png",
					"team2": "England",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313114.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Tue, 10 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 8,
					"team1": "Pakistan",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313129.logo.png",
					"team2": "Sri Lanka",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340000/340047.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "",
					"wDescription": ""
				},
				{
					"matchId": 9,
					"team1": "India",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313128.logo.png",
					"team2": "Afghanistan",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/321000/321005.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Wed, 11 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 10,
					"team1": "Australia",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340400/340493.png",
					"team2": "South Africa",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313125.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Thu, 12 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 11,
					"team1": "Bangladesh",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/341400/341456.png",
					"team2": "New Zealand",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340500/340505.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Fri, 13 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 12,
					"team1": "India",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313128.logo.png",
					"team2": "Pakistan",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313129.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Sat, 14 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 13,
					"team1": "Afghanistan",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/321000/321005.png",
					"team2": "England",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313114.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Sun, 15 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 14,
					"team1": "Australia",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340400/340493.png",
					"team2": "Sri Lanka",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340000/340047.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Mon, 16 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 15,
					"team1": "Netherlands",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313136.logo.png",
					"team2": "South Africa",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313125.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Tue, 17 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 16,
					"team1": "New Zealand",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340500/340505.png",
					"team2": "Afghanistan",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/321000/321005.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Wed, 18 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 17,
					"team1": "India",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313128.logo.png",
					"team2": "Bangladesh",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/341400/341456.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Thu, 19 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 18,
					"team1": "Australia",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340400/340493.png",
					"team2": "Pakistan",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313129.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Fri, 20 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 19,
					"team1": "Netherlands",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313136.logo.png",
					"team2": "Sri Lanka",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340000/340047.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Sat, 21 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 20,
					"team1": "England",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313114.logo.png",
					"team2": "South Africa",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313125.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "",
					"wDescription": ""
				},
				{
					"matchId": 21,
					"team1": "India",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313128.logo.png",
					"team2": "New Zealand",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340500/340505.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Sun, 22 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 22,
					"team1": "Afghanistan",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/321000/321005.png",
					"team2": "Pakistan",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313129.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Mon, 23 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 23,
					"team1": "Bangladesh",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/341400/341456.png",
					"team2": "South Africa",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313125.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Tue, 24 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 24,
					"team1": "Australia",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340400/340493.png",
					"team2": "Netherlands",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313136.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Wed, 25 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 25,
					"team1": "England",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313114.logo.png",
					"team2": "Sri Lanka",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340000/340047.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Thu, 26 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 26,
					"team1": "Pakistan",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313129.logo.png",
					"team2": "South Africa",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313125.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Fri, 27 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 27,
					"team1": "Australia",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340400/340493.png",
					"team2": "New Zealand",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340500/340505.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Sat, 28 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 28,
					"team1": "Bangladesh",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/341400/341456.png",
					"team2": "Netherlands",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313136.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "",
					"wDescription": ""
				},
				{
					"matchId": 29,
					"team1": "India",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313128.logo.png",
					"team2": "England",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313114.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Sun, 29 Oct '23",
					"wDescription": ""
				}
			],
			PendingMatches:[

				
				

				
				
				
				{
					"matchId": 30,
					"team1": "Afghanistan",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/321000/321005.png",
					"team2": "Sri Lanka",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340000/340047.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Mon, 30 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 31,
					"team1": "Bangladesh",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/341400/341456.png",
					"team2": "Pakistan",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313129.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Tue, 31 Oct '23",
					"wDescription": ""
				},
				{
					"matchId": 32,
					"team1": "New Zealand",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340500/340505.png",
					"team2": "South Africa",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313125.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Wed, 01 Nov '23",
					"wDescription": ""
				},
				{
					"matchId": 33,
					"team1": "India",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313128.logo.png",
					"team2": "Sri Lanka",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340000/340047.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Thu, 02 Nov '23",
					"wDescription": ""
				},
				{
					"matchId": 34,
					"team1": "Afghanistan",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/321000/321005.png",
					"team2": "Netherlands",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313136.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Fri, 03 Nov '23",
					"wDescription": ""
				},
				{
					"matchId": 35,
					"team1": "New Zealand",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340500/340505.png",
					"team2": "Pakistan",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313129.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Sat, 04 Nov '23",
					"wDescription": ""
				},
				{
					"matchId": 36,
					"team1": "Australia",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340400/340493.png",
					"team2": "England",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313114.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "",
					"wDescription": ""
				},
				{
					"matchId": 37,
					"team1": "India",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313128.logo.png",
					"team2": "South Africa",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313125.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Sun, 05 Nov '23",
					"wDescription": ""
				},
				{
					"matchId": 38,
					"team1": "Bangladesh",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/341400/341456.png",
					"team2": "Sri Lanka",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340000/340047.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Mon, 06 Nov '23",
					"wDescription": ""
				},
				{
					"matchId": 39,
					"team1": "Afghanistan",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/321000/321005.png",
					"team2": "Australia",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340400/340493.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Tue, 07 Nov '23",
					"wDescription": ""
				},
				{
					"matchId": 40,
					"team1": "England",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313114.logo.png",
					"team2": "Netherlands",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313136.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Wed, 08 Nov '23",
					"wDescription": ""
				},
				{
					"matchId": 41,
					"team1": "New Zealand",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340500/340505.png",
					"team2": "Sri Lanka",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340000/340047.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Thu, 09 Nov '23",
					"wDescription": ""
				},
				{
					"matchId": 42,
					"team1": "Afghanistan",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/321000/321005.png",
					"team2": "South Africa",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313125.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Fri, 10 Nov '23",
					"wDescription": ""
				},
				{
					"matchId": 43,
					"team1": "Australia",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/340400/340493.png",
					"team2": "Bangladesh",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/341400/341456.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Sat, 11 Nov '23",
					"wDescription": ""
				},
				{
					"matchId": 44,
					"team1": "England",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313114.logo.png",
					"team2": "Pakistan",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313129.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "",
					"wDescription": ""
				},
				{
					"matchId": 45,
					"team1": "India",
					"team1Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313128.logo.png",
					"team2": "Netherlands",
					"team2Flag": "https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_80/lsci/db/PICTURES/CMS/313100/313136.logo.png",
					"ground": "",
					"matchDayWeather": "",
					"matchDay": "Sun, 12 Nov '23",
					"wDescription": ""
				}
			],

			CurrentPointMap: [
				{
					"id": 1,
					"name": "India",
					"points": 12,
					"initialPoints": 12,
					"nrr": 1.405
				},
				{
					"id": 2,
					"name": "England",
					"points": 2,
					"initialPoints": 2,
					"nrr": -1.652
				},
				{
					"id": 3,
					"name": "Australia",
					"points": 8,
					"initialPoints": 8,
					"nrr": 0.970
				},
				{
					"id": 4,
					"name": "Pakistan",
					"points": 4,
					"initialPoints": 4,
					"nrr": -0.387
				},
				{
					"id": 5,
					"name": "South Africa",
					"points": 10,
					"initialPoints": 10,
					"nrr": 2.032
				},
				{
					"id": 6,
					"name": "New Zealand",
					"points": 8,
					"initialPoints": 8,
					"nrr": 1.232
				},
				{
					"id": 7,
					"name": "Bangladesh",
					"points": 2,
					"initialPoints": 2,
					"nrr": -1.338
				},
				{
					"id": 8,
					"name": "Afghanistan",
					"points": 4,
					"initialPoints": 4,
					"nrr": -0.969
				},
				{
					"id": 9,
					"name": "Sri Lanka",
					"points": 4,
					"initialPoints": 4,
					"nrr": -0.205
				},
				{
					"id": 10,
					"name": "Netherlands",
					"points": 4,
					"initialPoints": 4,
					"nrr": -1.277
				}
			]
		}
	],
	
	
}